// Custom.
import { CaretDownIcon, CheckIcon } from '@radix-ui/react-icons';
import { useState } from 'react';
import { ControllerRenderProps } from 'react-hook-form';

import { Button } from '../../primitives/button';
import {
  Command,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
} from '../../primitives/command';
import { FormControl, FormItem, FormMessage } from '../../primitives/form';
import { Popover, PopoverContent, PopoverTrigger } from '../../primitives/popover';
import { cn } from '../../utils/cn';

// TODO: use interface
type TCombobox = {
  className?: string;
  disabled?: boolean;
  field: ControllerRenderProps<any>;
  formMessageClassName?: string;
  fuzzy?: boolean;
  iconClassName?: string;
  iconPosition?: 'right' | 'left';
  model: { label?: string; value: string; icon?: any }[] | any[];
  pickCustomIconField?: string; // uses the `icon` field by default but any field from `model` can be selected
  placeholder?: string;
  onSelect: (value: string) => void;
};

/**
 * !Important This component will be deleted soon. Don't use it.
 * @deprecated Use `ComboboxModel` from element-ui
 */
export function Combobox({
  className,
  disabled = false,
  field,
  formMessageClassName,
  fuzzy = false,
  iconClassName,
  iconPosition = 'left',
  model,
  pickCustomIconField,
  placeholder = 'Seleccionar',
  onSelect,
}: TCombobox) {
  const [open, setOpen] = useState(false);

  const filter = fuzzy
    ? undefined // fuzzy
    : (value: string, search: string) => {
        // contiguous matches
        return value.toLowerCase().includes(search.toLowerCase()) ? 1 : 0;
      };

  const formControlLabel = (field.value
    ? model.find(({ value }) => value === field.value)
    : undefined) ?? { icon: '', label: placeholder, value: placeholder };

  return (
    <FormItem className="flex flex-col">
      <Popover open={open} onOpenChange={setOpen}>
        <PopoverTrigger asChild>
          <FormControl>
            <Button
              disabled={disabled}
              variant="ghost"
              role="combobox"
              aria-expanded={open}
              className={cn(!field.value && 'text-muted-foreground', className)}
            >
              {iconPosition === 'right'
                ? formControlLabel?.label === '' || !formControlLabel?.label
                  ? formControlLabel?.value
                  : formControlLabel?.label
                : null}

              {pickCustomIconField && formControlLabel?.[`${pickCustomIconField}`] ? (
                <span className={iconClassName}>
                  {formControlLabel?.[`${pickCustomIconField}`]}
                </span>
              ) : null}
              {!pickCustomIconField && formControlLabel?.icon ? (
                <div className={iconClassName}>{formControlLabel?.icon}</div>
              ) : null}

              {iconPosition === 'left'
                ? formControlLabel?.label === '' || !formControlLabel?.label
                  ? formControlLabel?.value
                  : formControlLabel?.label
                : null}
              <CaretDownIcon className="ml-2 size-4 shrink-0 opacity-50" />
            </Button>
          </FormControl>
        </PopoverTrigger>
        <PopoverContent align="start" className="w-full p-0">
          <Command filter={filter}>
            <CommandInput placeholder="Buscar" className="h-9" />
            <CommandList>
              <CommandEmpty>Sin resultados 🫥</CommandEmpty>
              <CommandGroup>
                {model.map((modelItem) => {
                  const { label, value, icon } = modelItem;
                  return (
                    <CommandItem
                      className="text-sm"
                      value={value}
                      key={value}
                      onSelect={() => {
                        onSelect(value);
                        setOpen(false);
                      }}
                    >
                      {iconPosition === 'right' ? (
                        <span>{label === '' || !label ? value : label}</span>
                      ) : null}

                      {pickCustomIconField && modelItem?.[`${pickCustomIconField}`] ? (
                        <span className={iconClassName}>
                          {modelItem?.[`${pickCustomIconField}`]}
                        </span>
                      ) : null}
                      {!pickCustomIconField && icon ? (
                        <div className={iconClassName}>{icon}</div>
                      ) : null}

                      {iconPosition === 'left' ? (
                        <span>{label === '' || !label ? value : label}</span>
                      ) : null}
                      <CheckIcon
                        className={cn(
                          'ml-auto size-4',
                          value === field.value ? 'opacity-100' : 'opacity-0',
                        )}
                      />
                    </CommandItem>
                  );
                })}
              </CommandGroup>
            </CommandList>
          </Command>
        </PopoverContent>
      </Popover>
      <FormMessage className={formMessageClassName} />
    </FormItem>
  );
}
